var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[(_vm.visible)?_c('div',{staticClass:"notify"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }